import { render } from "./JeuComponent.vue?vue&type=template&id=62c3b166"
import script from "./JeuComponent.vue?vue&type=script&lang=js"
export * from "./JeuComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__